import React, { useRef, useState } from 'react';

function BlockBastSandbox() {

    const squareRef = useRef(null);
    const cellRef = useRef(null);


    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState({ x: 100, y: 100 });
    const offset = useRef({ x: 0, y: 0 });

    const handlePointerDown = (e) => {
        e.preventDefault();

        e.target.setPointerCapture(e.pointerId);

        offset.current = {
            x: e.clientX - position.x,
            y: e.clientY - position.y
        };

        setIsDragging(true);
    };

    const handlePointerMove = (e) => {
        if (!isDragging) return;

        const newX = e.clientX - offset.current.x;
        const newY = e.clientY - offset.current.y;

        setPosition({ x:newX, y: newY });
    };

    const handlePointerUp = (e) => {
        e.target.releasePointerCapture(e.pointerId);
        setIsDragging(false);
    };

    return (
        <div className='game'>

            <div // cell for box
                ref={cellRef}
                style={{
                    position: 'fixed',
                    left: 200,
                    top: 200,
                    width: 82,
                    height: 82,
                    backgroundColor: '#fff',
                    opacity: 0.5,
                    border: '2px solid #000',
                }}
            />


            <div // draggable box
                ref={squareRef}
                onPointerDown={handlePointerDown}
                onPointerMove={handlePointerMove}
                onPointerUp={handlePointerUp}
                style={{
                    position: 'absolute',
                    left: position.x,
                    top: position.y,
                    width: 80,
                    height: 80,
                    backgroundColor: isDragging? '#ff6b6b' : '#4ecdc4',
                    cursor: 'grab',
                    userSelect: 'none',
                    touchAction: 'none',
                }}
            />
    
        </div>
    );
}

export default BlockBastSandbox;
